var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RandomStyle',{ref:"RandomTextArea",attrs:{"random-word-data":_vm.RandomData}}),_c('SimpleKeyboard',{ref:"Keyboard",attrs:{"input":_vm.input,"show-gesture":true},on:{"onChange":_vm.onChange,"onKeyPress":_vm.onKeyPress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }